export default "__VITE_PUBLIC_ASSET__2d788e1f__"